import React from "react";
import AccordionData from "../../assets/data/AccordionData";
import FAQAccordion from "../../components/FAQAccordion";
const FAQ = ({ question, answer }) => {
  return (
    <div className="FAQ" style={{ fontSize: "32px" }}>
      <div className="FAQ__container">
        <center>
          <p>Frequently Asked Questions</p>
        </center>
        {AccordionData.map((c, index) => (
          <FAQAccordion key={index} question={c.question} answer={c.answer} />
        ))}
      </div>
    </div>
  );
};

export default FAQ;
